import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";

import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../../common/Button";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { Country, State } from "../../../../utils/apis/masters/masters";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);

  const id = props.show;
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city] = useState([]);
  const [, setData] = useState();
  const [, setZone] = useState([]);

  const [formData, setFormData] = useState({
    country_id: "",
    state_id: "",
    city_id: "",
    name: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    if (e.name === "state_id" || e.name === "city_id") {
      setFormData({
        ...formData,
        [e.name]: e.value,
      });
    } else if (e.name === "country_id") {
      setFormData({
        ...formData,
        [e.name]: e,
        state_id: "",
        city_id: "",
      });
      getSelectedState(e.value);
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  async function getSelectedState(id) {
    const response = await State(id);
    if (response.success) {
      setState(response.data);
    }
  }


  const GetAllCountry = async () => {
    const response = await Country();

    const option = [];
    if (response.success) {
      response?.data?.forEach((data) => {
        option.push({
          value: data.id,
          name: "country_id",
          label: data.name,
        });
      });
    }
    setCountry(option);
  };

  const GetAllZone = async () => {
    const response = await getData("/masters/zone");

    const option = [];
    if (response.success) {
      response?.data?.data?.forEach((data) => {
        option.push({
          value: data.id,
          name: "zone_id",
          label: data.name,
        });
      });
    }
    setZone(option);
  };

  useEffect(() => {
    GetAllCountry();
    GetAllZone();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = await Validation.FormValidation({
      classname: ".pincodeclass",
    });

    const validationErrorsSelect = Validation.SelectValidation({
      classname: ".pincodeclass",
    });

    if (validationErrors && validationErrorsSelect) {
      try {
        const response = await postData(`/masters/pincode/${id}`, formData);
        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/pincode/${id}`);
    setData(response);

    setFormData(response?.data);

    const res = await getData("/masters/allcountry");

    const option = [];
    if (res.success) {
      res?.data?.forEach((data) => {
        option.push({
          value: data.id,
          name: "country_id",
          label: data.name,
        });
      });
    }
    setCountry(option);
  };

  useEffect(() => {
    GetEditData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Pincode</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="pincodeclass"
                          >
                            <Row>
                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      Select Country{" "}
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="country_id"
                                        className="custom-select input-mandatory"
                                        onChange={handleChange}
                                        value={formData?.country_id}
                                        options={country}
                                      />

                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      Select State{" "}
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="state_id"
                                        className="custom-select input-mandatory"
                                        onChange={handleChange}
                                        value={formData.state_id}
                                        options={state?.map((stateOption) => ({
                                          value: stateOption.id,
                                          name: "state_id",
                                          label: stateOption.name,
                                        }))}
                                      />

                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      Select City{" "}
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="city_id"
                                        className="custom-select input-mandatory"
                                        onChange={handleChange}
                                        value={formData.city_id}
                                        options={city?.map((stateOption) => ({
                                          value: stateOption.id,
                                          name: "city_id",
                                          label: stateOption.name,
                                        }))}
                                      />

                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Pincode
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name="name"
                                            value={formData?.name}
                                            onChange={handleChange}
                                            placeholder="Pincode"
                                            id="inputEmail3"
                                            maxLength={6}
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        <span className="error-message"></span>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                              {/* </Row> */}

                              <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                  <Link>
                                    <CancelButton
                                      name={"cancel"}
                                      handleClose={props.handleClose}
                                    />
                                  </Link>
                                  <SaveButton
                                    name={"save"}
                                    handleSubmit={handleSubmit}
                                  />
                                </div>
                              </Row>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
